export default {
  title: 'Ajan päivitys!',
  labels: {
    old_time: 'Edellinen noutoaika:',
    new_time: 'Uusi noutoaika:',
  },
  buttons: {
    print: 'Tulosta ja sulje',
    got_it: 'Selvä',
  },
  feedback: {
    new_prep_time: 'Toimitusaikaa on päivitetty. Mukauta valmisteluaikatauluasi vastaavasti.',
  },
  toasts: {
    something_went_wrong: 'Jokin meni pieleen, yritä uudelleen',
  },
};
